import { useDispatch, useSelector } from "react-redux";

// Actions
import { openLandmarkNearbyForm } from "../../../actions/location-summary/LocationSummaryActions";

// Utils and Constants
import { formatText } from "../../../common-utils/string-utils/StringUtils";
import {
  FormDataTargets,
  LandmarksNearbyConstants,
} from "../../../constants/GeneralConstants";
import {
  filterLandmarksWhichHaveName,
  getCategorizedPoints,
  sortPointsByDistance,
} from "./LocationSummaryUtils";

// Components
import LandmarkNearbyForm from "./LandmarksNearbyForm";

/**
 * Landmarks Component
 */
export default function Landmarks({
  className = "",
  points = [],
  latitude,
  longitude,
  radius = 1000,
  mediaTitle = "",
}) {
  const dispatch = useDispatch();

  // landmark nearby modal
  const openLandmarkNearbyModal = useSelector(
    (state) => state.locationSummary.openLandmarkNearbyModal
  );

  // filter points which have name
  const pointsWithName = filterLandmarksWhichHaveName(points);

  // no points
  if (pointsWithName.length === 0) {
    return null;
  }

  // get points categorization
  const categorizedPointsMap = getCategorizedPoints(pointsWithName);

  return (
    <div className={`landmarks ${className}`}>
      <p>
        <strong>Landmarks nearby</strong>
        <span
          className="text-primary cursor-pointer ml-3"
          title={"Click to see all landmarks and download report"}
          data-toggle="modal"
          data-target={`#${FormDataTargets.landmarkNearbyForm}`}
          onClick={() => dispatch(openLandmarkNearbyForm())}
        >
          (Show All)
        </span>
      </p>

      {LandmarksNearbyConstants.map((landmark, i) => {
        const { key, label } = landmark;
        const landmarksPoints = categorizedPointsMap?.[key] || [];
        const pointsCount = landmarksPoints.length;
        const sortedByDistancePoints = sortPointsByDistance(
          landmarksPoints,
          latitude,
          longitude
        );
        const landMarkName = sortedByDistancePoints[0]?.name;
        return (
          <p key={i}>
            {label} ({pointsCount}): {formatText(landMarkName)}
          </p>
        );
      })}

      {/* MODALS */}
      {/* Landmark Nearby Modal */}
      {openLandmarkNearbyModal && (
        <LandmarkNearbyForm
          latitude={latitude}
          longitude={longitude}
          radius={radius}
          mediaTitle={mediaTitle}
          categorizedPointsMap={categorizedPointsMap}
        />
      )}
    </div>
  );
}
